import { orderBy } from 'lodash';

import { Action } from '../../actions';
import {
    SET_FREELANCER_COOPERATION_STATUS,
    SET_FREELANCERS_LIST_PAGE_STATUS,
    SORT_FREELANCERS_LIST_DATA,
    UPDATE_FREELANCERS_LIST_DATA,
    UPDATE_SINGLE_FREELANCER_DATA
} from '../../actions/freelancers/freelancers-list';
import { routeToKeyMap } from '../../service/FreelancersListHelpers';
import {
    FreelancerPageStates,
    FreelancersList,
    FreelancersListItem
} from '../../typings/freelancers';
import { State } from '../../typings/state';

const initialState = {
    freelancersListItems: [],
    pageStatus: FreelancerPageStates.PENDING
};

export function freelancersList(
    state: FreelancersList = initialState,
    action: Action,
    fullState: State
): FreelancersList {
    switch (action.type) {
        case UPDATE_FREELANCERS_LIST_DATA:
            return {
                ...state,
                freelancersListItems: action.sortParams
                    ? orderBy<FreelancersListItem>(
                          action.payload,
                          [routeToKeyMap[action.sortParams.key]],
                          [action.sortParams.direction]
                      )
                    : action.payload
            };
        case UPDATE_SINGLE_FREELANCER_DATA:
            const itemIdx = state.freelancersListItems.findIndex(
                item => item.freelancerId === action.freelancerId
            );
            return {
                ...state,
                freelancersListItems: [
                    ...state.freelancersListItems.slice(0, itemIdx),
                    {
                        ...state.freelancersListItems[itemIdx],
                        statusModerate: action.payload.statusModerate,
                        avatarLink: action.payload.avatarLink,
                        about: action.payload.about
                    },
                    ...state.freelancersListItems.slice(itemIdx + 1)
                ]
            };
        case SORT_FREELANCERS_LIST_DATA:
            const sortField = routeToKeyMap[action.sortParams.key];
            return {
                ...state,
                freelancersListItems: orderBy<FreelancersListItem>(
                    state.freelancersListItems,
                    [sortField],
                    [action.sortParams.direction]
                )
            };
        case SET_FREELANCERS_LIST_PAGE_STATUS:
            return {
                ...state,
                pageStatus: action.status
            };
        case SET_FREELANCER_COOPERATION_STATUS:
            const idx = state.freelancersListItems.findIndex(
                item => item.freelancerId === action.freelancerId
            );
            return {
                ...state,
                freelancersListItems: [
                    ...state.freelancersListItems.slice(0, idx),
                    {
                        ...state.freelancersListItems[idx],
                        isCurrentFreelancer: true
                    },
                    ...state.freelancersListItems.slice(idx + 1)
                ]
            };
        default:
            return state;
    }
}
